<template>
  <div class="product-detail-container">
    <!-- 顶部商品信息 -->
    <div class="product-header">
      <div class="product-image">
        <img :src="https + fathMessage.info.image" alt="商品图片" />
      </div>
      <div class="product-info">
        <div class="product-price">
          <span style="font-size: 12px; margin-right: 6px">¥</span>
          <span>{{ fathMessage.info.price }}</span>
        </div>
        <div class="product-stock">库存充足</div>
        <div class="product-stock">请选择商品尺寸</div>
      </div>
    </div>
    <div class="address" @click="my_address">
      <div>
        <span style="font-size: 14px">地址：</span>
        <span style="margin-right: 10px; font-weight: 400">{{
          localData.info.address ? localData.info.address.name : ""
        }}</span>
        <span style="font-weight: 400">{{
          localData.info.address ? localData.info.address.address : ""
        }}</span>
      </div>
      <img
        style="width: 15px; height: auto"
        src="../assets//arrow-right.png"
        alt=""
      />
    </div>
    <!-- 颜色选择 -->
    <div class="section">
      <template v-for="(item, key, index) in localData.info.spec">
        <div :key="index">
          <div
            class="section-title"
            style="margin-bottom: 13px; font-weight: 700"
          >
            {{ key }}
          </div>
          <div class="color-options">
            <span
              v-for="(color, index) in item"
              :key="index"
              class="color-option"
              :class="{ active: selectedSpecs[key] === color }"
              @click="selectSpec(key, color)"
            >
              {{ color }}
            </span>
          </div>
        </div>
      </template>
    </div>
    <!-- 购买数量 -->
    <div class="section" style="padding: 10px 0">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div class="section-title" style="font-weight: 700; font-size: 16px">
          购买数量
        </div>
        <div class="quantity-selector">
          <button class="qty-btn" @click="decreaseQty">-</button>
          <span class="qty-value">{{ quantity }}</span>
          <button class="qty-btn" @click="increaseQty">+</button>
        </div>
      </div>
    </div>
    <!-- 支付方式 -->
    <div class="section" style="padding-top: 25px">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div class="section-title" style="font-weight: 700; font-size: 16px">
          支付方式
        </div>
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio
            @click="pay_type"
            name="1"
            checked-color="#ed6b5a"
            icon-size="16px"
            >支付宝支付</van-radio
          >
          <van-radio
            @click="pay_type"
            name="2"
            checked-color="#ed6b5a"
            icon-size="16px"
            >微信支付</van-radio
          >
        </van-radio-group>
      </div>
    </div>
    <!-- 底部操作按钮 -->
    <div class="action-buttons">
      <p style="font-weight: 700; color: red; font-size: 18px">
        <span style="font-size: 12px; font-weight: 400">合计：￥</span>
        <span>{{ total_price }}</span>
      </p>
      <button
        @click="btn_buy"
        :disabled="wechat"
        class="btn buy-now"
        :class="{ buy_active: wechat }"
      >
        {{ btn_text }}
      </button>
    </div>
    <!-- 选择地址 -->
    <van-popup
      v-model="address_show"
      position="bottom"
      closeable
      :style="{
        height: '75%',
        paddingBottom: 'env(safe-area-inset-bottom)', // 关键代码
      }"
      :close-on-popstate="false"
    >
      <div class="title">请选择收获地址</div>
      <div class="nav">
        <div class="left">常用地址</div>
        <div @click="add_address" class="right">+新增地址</div>
      </div>
      <div class="custom-address-list">
        <div
          v-for="item in list"
          :key="item.id"
          class="custom-address-item"
          :class="{ 'address-active': item.isActive }"
          @click="sele_address(item)"
        >
          <div class="address-content">
            <!-- 地址内容展示 -->
            <div class="address-detail">
              {{ item.address }}
            </div>
            <div class="name-tel">
              <span style="margin-right: 20px">{{ item.name }}</span>
              <span>{{ item.tel }}</span>
            </div>
          </div>

          <!-- 删除按钮 -->
          <div class="action-buttons">
            <van-button
              style="border: none; color: #de6262; background: transparent"
              size="small"
              @click.stop="handleDelete(item.id)"
            >
              删除
            </van-button>
          </div>
        </div>
        <!-- 添加地址按钮 -->
        <van-button block type="primary" @click="btn_select" class="add-button">
          确定
        </van-button>
      </div>
    </van-popup>
  </div>
</template>
  <script>
import { zfb_pay } from "@/utils/request";
import { address } from "@/utils/request";
import { del_address } from "@/utils/request";
import axios from "axios";
export default {
  data() {
    return {
      chosenAddressId: "",
      localData: this.fathMessage,
      list: [],
      chosenAddress: "",
      address_show: false,
      btn_text: "立即购买",
      wechat: false,
      radio: "1",
      sizeArr: [],
      https: "",
      selectedSpecs: {}, // 改为对象存储所有选中的规格
      quantity: 1,
      message: "",
    };
  },
  methods: {
    async btn_buy() {
      try {
        // 验证必填信息
        if (!this.fathMessage.info.address.id) {
          this.$toast.fail("请选择收货地址");
          return;
        }
        // 验证是否选择了所有规格
        const specKeys = Object.keys(this.fathMessage.info.spec);
        if (Object.keys(this.selectedSpecs).length !== specKeys.length) {
          this.$toast.fail("请选择完整的商品规格");
          return;
        }
        // 显示加载状态
        this.paying = true;
        this.btn_text = "正在跳转支付...";
        // 调用支付接口
        const res = await zfb_pay({
          data: {
            token: localStorage.getItem("auth_token"),
            goods_id: this.goodsid,
            address_id: this.fathMessage.info.address.id,
            specs: this.specString, // 已经是 "尺码::S;;颜色::红" 格式
            num: this.quantity,
          },
        });
        // 处理支付返回结果
        console.log(res.data.data.url);

        if (res.data.code === 200 && res.data.data.url) {
          // 处理支付宝返回的HTML表单
          this.handleAlipayResponse(res.data.data.url);
        } else {
          this.$toast.fail(res.message || "获取支付链接失败");
        }
      } catch (error) {
        console.error("支付错误:", error);
        this.$toast.fail("支付请求失败");
      } finally {
        this.paying = false;
        this.btn_text = "立即购买";
      }
    },
    // 新增方法：处理支付宝返回的HTML表单
    handleAlipayResponse(html) {
      // 创建临时div存放支付宝返回的表单
      const div = document.createElement("div");
      div.innerHTML = html;
      document.body.appendChild(div);

      // 自动提交表单
      const form = div.querySelector("form");
      if (form) {
        form.submit();
      } else {
        this.$toast.fail("支付表单加载失败");
        console.error("支付宝返回的表单不存在:", html);
      }
      // 提交后移除临时div
      setTimeout(() => {
        document.body.removeChild(div);
      }, 1000);
    },
    pay_type() {
      if (this.radio == 2) {
        this.$toast.fail("微信支付申请中");
        this.wechat = true;
        this.btn_text = "暂未开放";
      } else {
        this.wechat = false;
        this.btn_text = "立即购买";
      }
    },
    my_address() {
      //修改地址弹窗
      this.address_show = true;
    },
    selectSpec(key, value) {
      // 使用Vue.set确保响应式更新
      this.$set(this.selectedSpecs, key, value);
    },
    selectColor(color) {
      this.selectedColor = color;
    },
    increaseQty() {
      this.quantity++;
    },
    decreaseQty() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    //选择地址
    sele_address(item) {
      this.chosenAddress = item;
      this.chosenAddressId = item.id;
      //为选中的地址添加active状态
      this.list = this.list.map((addressItem) => ({
        ...addressItem,
        isActive: addressItem.id === item.id, // 添加isActive标记
      }));
    },
    updateAddress(newAddress) {
      console.log(newAddress);
      // 深度拷贝shopsData以避免直接修改响应式对象的问题
      const updatedData = JSON.parse(JSON.stringify(this.fathMessage));
      // 更新地址信息
      if (updatedData.info && updatedData.info.address) {
        updatedData.info.address = newAddress;
        // 更新本地存储的旧地址
        localStorage.setItem("old_address", JSON.stringify(newAddress));
        // 更新响应式数据
        this.localData = updatedData;
      }
    },
    btn_select() {
      this.address_show = false;
      const oldAddress = JSON.parse(localStorage.getItem("old_address"));
      if (address && oldAddress && this.chosenAddress.id !== oldAddress.id) {
        localStorage.setItem("address", JSON.stringify(this.chosenAddress));
        this.updateAddress(this.chosenAddress);
        this.$toast("地址更新成功");
      }
    },
    add_address() {
      this.$router.push("/add_address");
    },
    handleDelete(id) {
      this.$dialog
        .confirm({
          title: "删除地址",
          message: "确定删除这个地址吗？",
        })
        .then(async () => {
          this.list = this.list.filter((item) => item.id !== id);
          if (this.chosenAddressId === id) {
            this.chosenAddressId = this.list[0]?.id || "";
          }
          await del_address({
            data: {
              token: localStorage.getItem("auth_token"),
              id,
              type: 2,
            },
          });
          this.$toast.success("删除成功");
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  props: ["fathMessage", "goodsid"], // 或使用对象形式定义类型和默认值
  async mounted() {
    this.https = axios.defaults.baseURL;
    var myObject = this.fathMessage.info.spec;
    var arr = [];
    Object.keys(myObject).forEach((key) => {
      arr.push(myObject[key][0]);
    });
    this.sizeArr = arr;
    // 用户地址列表
    const res = await address({
      data: {
        token: localStorage.getItem("auth_token"),
      },
    });
    this.list = res.data.data.map((item) => ({
      id: item.id,
      name: item.receiver_name,
      tel: item.receiver_phone,
      // 关键修改：address必须是完整字符串
      address: `${item.province}${item.city}${item.district}${item.street}`,
      province: item.province,
      city: item.city,
      county: item.district,
      addressDetail: item.street,
      isDefault: item.isdefault === 1,
      isActive: item.id == this.localData.info.address.id, // 默认选中默认地址
    }));

    const defaultItem = this.list.find((item) => item.isDefault === true);
    this.chosenAddressId = defaultItem ? defaultItem.id : "";
  },
  watch: {
    fathMessage(newVal) {
      // 当父组件数据变化时更新本地副本
      this.localData = newVal;
    },
  },
  computed: {
    total_price() {
      var result = this.fathMessage.info.price * this.quantity;
      return result.toFixed(2);
    },
    // 新增计算属性拼接规格字符串
    specString() {
      return Object.entries(this.selectedSpecs)
        .map(([key, value]) => `${key}::${value}`)
        .join(";;");
    },
  },
};
</script>
<style scoped>
.product-detail-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 15px;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.product-header {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  /* margin-bottom: 15px; */
}

.product-image {
  width: 80px;
  height: 80px;
  margin-right: 15px;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.product-info {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: start;
}

.product-price {
  font-size: 20px;
  font-weight: bold;
  color: #b63343;
  margin-bottom: 10px;
}

.product-stock {
  font-size: 12px;
  color: #9c9a9a;
}

.section {
  padding: 15px 0;
}

.section-title {
  font-size: 14px;
  color: #333;
  text-align: left;
}

.color-options {
  display: flex;
  gap: 10px;
  font-size: 12px;
  margin-bottom: 16px;
}

.color-option {
  padding: 6px 15px;
  /* border: 1px solid #ddd; */
  border-radius: 4px;
  cursor: pointer;
  background: #f2efef;
}

.color-option.active {
  border-color: #ff5000;
  color: #ff5000;
  border: 1px solid #ff5000;
  background-color: #fff5f5;
}

.quantity-selector {
  display: flex;
  align-items: center;
}

.qty-btn {
  width: 30px;
  height: 30px;
  border: 1px solid #ddd;
  background: #fff;
  font-size: 16px;
  cursor: pointer;
}

.qty-value {
  width: 40px;
  text-align: center;
}

.message-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.btn {
  flex: 1;
  height: 43px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.add-cart {
  background: #ff9500;
  color: white;
}

.buy_active {
  background: #a0a0a0 !important;
}

.buy-now {
  background: #fa4730;
  color: white;
  font-size: 14px;
  font-weight: 400;
  border-radius: 30px;
}

::v-deep .van-radio__label {
  font-size: 13px !important;
}

.address {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f2efef;
  padding: 10px 0;
  text-align: left;
  font-weight: 700;
  font-size: 13px;
  padding-left: 4px;
}

.custom-address-list {
  padding: 10px;
}

.custom-address-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  padding-bottom: 6px;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.address-content {
  flex: 1;
}
.address-active {
  color: orange !important;
  background: #fcf7f3;
}

.name-tel {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
  /* color: #504f4f; */
}

.address-detail {
  /* color: #000; */
  font-size: 15px;
  margin-bottom: 8px;
  text-align: left;
  font-weight: 700;
}

.default-tag {
  display: inline-block;
  padding: 2px 6px;
  background: #1989fa;
  color: white;
  border-radius: 4px;
  font-size: 12px;
}

.add-button {
  margin-top: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fa4730;
  border: none;
  border-radius: 2px;
}
.title {
  padding-top: 16px;
  font-weight: 700;
  font-size: 15px;
}
.nav {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
}
.left {
  font-weight: 700;
  font-size: 13px;
}
.right {
  color: #fa6626;
}
</style>